<template>
	<div class="form-confirmation">
		<h2>Congratulations!</h2>
		<h3>Your message has been sent!</h3>
		<p>Please be patient while your message<br> is sent to the Wall of Giving.</p>

		<div class="entries">
			<strong>
				<count-up
					:startVal=0
					:duration=5
					:endVal="$store.state.entries"
				/>
			</strong>
			<p>Messages Sent</p>
		</div>

		<h3 class="footer__more">More Messages = More Love!</h3>
		<p>Tell your friends about it</p>
		<a href="#" @click.prevent="shareFacebook" class="button button--fb">Share on Facebook</a>
		<p>OR</p>
		<a :href="constants.SITE_URL" class="button">Send Another!</a>
	</div>
</template>

<script>
import CountUp from 'vue-countup-v2';
import animateScrollTo from 'animated-scroll-to';
import * as constants from '@/constants';

export default {
	components: { CountUp },
	computed: {
		constants: () => constants,
	},
	mounted () {
		animateScrollTo(document.querySelector('.section-form'), { speed: 1000 });
	},
	methods: {
		shareFacebook () {
			// eslint-disable-next-line
			FB.ui({
				method: 'share',
				href: constants.SITE_URL,
			}, response => {});
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../../assets/less/default.less';

	.form-confirmation { padding-bottom: 2rem; }
	h2 { position: relative; font-size: 30/16rem; text-transform: uppercase;
		&:before { .pseudo(); .top-left(-10px, -10px); .size(25px, 30px); .bg('../../assets/images/ico-lines_animated.svg', 0 0 / contain); transform: rotate(-10deg); }
		&:after { .pseudo(); .top-right(-10px, -10px); .size(25px, 30px); .bg('../../assets/images/ico-lines_animated.svg', 0 0 / contain); transform: rotate(10deg) scaleX(-1); }
	}
	h3 { width: 80%; margin: 0 auto; font-size: 24/16rem;
		&.footer__more { width: 100%; margin-bottom: -.5rem; font-size: 18/16rem; text-transform: uppercase;
			+ p { margin-bottom: 1.3rem; }
		}
	}

	.entries { position: relative; display: inline-block; margin: .5rem auto 3rem; padding: 60px 0; .bold();
		background-image: url(../../assets/images/bg-confirmation-hearts-top.svg), url(../../assets/images/bg-confirmation-hearts-bottom.svg);
		background-position: 0 10px, 0 100%;
		background-repeat: repeat-x, repeat-x;
		&:before { .pseudo(); .size(230px, 215px); .top-left(0, -230px/3*2); .bg('../../assets/images/bg-confirmation-hearts-left.svg'); }
		&:after { .pseudo(); .size(230px, 215px); .top-right(0, -230px/3*2); .bg('../../assets/images/bg-confirmation-hearts-right.svg'); }
		strong { display: inline-block; margin: 0; font-size: 60/14rem; line-height: 1; transform: translateY(5px) }
		p { margin: 0; line-height: 1;
			&:after { .top-right(30px,-130px, 10); .pseudo(); .size(70px,62px); .bg('../../assets/images/ico-confirmation-you.svg'); }
		}
	}

	.button { display: block; max-width: 240px; margin: 0 auto; padding: .8rem 0.5rem; border-radius: 30px; background-color: @green; color: white; .bold(); text-decoration: none;
		&:hover { background-color: darken(@green, 10); }
		&--fb { background-color: @blue;
			&:before { .pseudo(); .size(7px,15px); margin-right: .6em; background: transparent url(../../assets/images/ico-facebook.svg) 0 0 no-repeat; vertical-align: middle; }
			&:hover { background-color: darken(@blue, 10); }
		}
		+ p { margin: .5rem 0; }
	}
</style>



// WEBPACK FOOTER //
// src/components/TheForm/TheFormConfirmation.vue